<div class="news-banner" *ngIf="isConnected() && news.length > 0"
     #banner
     (touchstart)="onTouchStart($event)"
     (touchend)="onTouchEnd($event)"
     (mouseenter)="pause()"
     (mouseleave)="resume()">

  <div class="news-banner__viewport">
    <div class="news-banner__slide"
         *ngFor="let item of news; let i = index"
         [class.news-banner__slide--active]="i === activeIndex"
         [class.news-banner__slide--exit]="i === exitIndex"
         [innerHTML]="item | linkify">
    </div>
  </div>
</div>
